<template>
    <div id="tzgg-body" ref="tzggElement">
        <CCBlockFrame :header="header">
            <ul v-if="allDataList.length > 0" id="item-body" class="autoStyle">
                <template class="link-message">
                    <li v-for="(item, index) in allDataList" :key="index" class="link-message" @click="onCellLink(item, index)">
                        <div class="item" :style="{fontWeight: item.passenger.isRead==0?'700':'400'}">
                            <!-- <div v-if="item.readed=='0'" class="title" style="font-weight:700;"><span style="display:flex;"><span style="display: block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.flSubject }}</span> <span style="line-height: 30px;"><svg-icon style="color: #9B9B9B;font-size: 20px;" class-name="newT" icon-class="newT" /></span></span></div> -->
                            <div class="title" style="color: #333333">
                                <span class="msg">{{ item.flSubject }}</span>
                            </div>
                            <svg-icon v-if="item.isAttach == 'yes'" style="color: #9b9b9b; float: right" class-name="attachIcon" icon-class="attachIcon" />
                            <div class="bottom">
                                <!-- <span style="text-align:left" class="name">{{ item.wfNodeNames }}</span> -->
                                <span style="text-align: right" class="name">{{ item.flCreateDate }}</span>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <div v-else>
                <div slot="empty" style="text-align: center; margin-top: 30px">
                    <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                    <br />
                    <span v-text-lbl="'common.noData'" style="font-size: 15px; color: #dbdbdb">暂无数据</span>
                </div>
            </div>
        </CCBlockFrame>
    </div>
</template>

<script>
const moment = require('moment')
const nowTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
import { mapGetters } from 'vuex'
export default {
    name: 'PatyBuildingActivities',
    components: {},
    filters: {
        dateTrans(date) {
            if (!date) return ''
            return window.moment(date).format('YYYY-MM-DD HH:mm')
        }
    },
    props: {
        title: { type: String, default: '公告' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            // 全部数据列表
            allDataList: [],
            // 数据列表
            dataList: [],
            header: {
                title: '通知公告',
                more: true,
                icon: this.appletData.icon,
                code: 'dzggPublished'
            },
            listdataConfig: {
                // orderBy: 'pushTime desc',
                listpageViewUrl: 'ecoa.dzgg.listPublished',
                pageNum: 1,
                pageSize: 10000
                // order: 'asc'
                // urlsearch: `status<:2;endTime>:${nowTime};startTime<:${nowTime}`

                // listpageViewUrl: 'djgl.inforContent.list_yfb.vue',
                // urlsearch: 'flFormName!:通知公告'
            }
        }
    },
    computed: {
        ...mapGetters(['loginUser', 'routes'])
    },
    watch: {},
    created() {
        this.getAllData()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        getAllData() {
            this.$app
                .listdata('/ecoa/dzgg/listdataWithEffective', this.listdataConfig)
                .then((res) => {
                    console.log('通知公告', res)

                    this.allDataList = res.body.pageInfo.list

                    // const length = this.allDataList.length
                    // if (length < 5 && length > 0) {
                    //     for (let i = 0; i < 5 - length; i++) {
                    //         this.allDataList.push({})
                    //         // this.header.title.push({ name: this.allDataList[i].type, code: 'dzggPublished' })
                    //     }
                    // }
                    // this.transAllData()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 全部数据列表转化
        transAllData() {
            const cateO = {}
            this.allDataList.forEach((v) => {
                if (!cateO[v.flFormName]) {
                    cateO[v.flFormName] = {
                        name: v.type,
                        click: () => {
                            this.getData(cateO[v.flFormName].dataList)
                        },
                        dataList: [],
                        code: 'dzggPublished'
                    }
                }
                cateO[v.flFormName].dataList.push(v)
            })
            const cateList = Object.values(cateO)
            const newarr = []
            cateList.forEach((item) => {
                newarr.push(item)
            })
            // this.$set(this.header, 'title', newarr)
            this.getData(newarr[0].dataList)
            newarr.forEach((item) => {
                item.dataList.push({})
            })
        },
        getData(dataList) {
            console.log('通知公告', dataList)

            this.$set(this, 'dataList', dataList)
        },
        onCellLink(row) {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                this.$bus.emit('openDefaultDialog', this.appletData.name)
                return
            }
            if (row.id) {
                let that = this
                var openPage = window.open('/#/viewcontent?wfEngineUrl=ecoa/dzgg&busiDataId=' + row.id + '&viewContent=1' + `&logoTitle=电子公告/${row.flSubject}`)
                openPage.addEventListener('unload', function () {
                    // 在页面B关闭时执行的代码
                    // 可以在此处触发页面A的相应操作
                    //  that.$bus.emit('refreshListData')
                    that.getAllData()
                    that.$bus.emit('shuaxing', true)
                })
            }
        }
    }
}
</script>

  <style scoped lang="scss">
#tzgg-body {
    height: 100%;
    // @import url(); 引入公共css类
    #item-body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        .link-message + .link-message {
            border-top: 1px dashed #ebeef5;
            // border-top:none !important;
        }
        .link-message {
            width: 100%;
            height: 71px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            list-style: none;
            padding: 10px 20px;
            .item {
                // padding: 10px 0;
                width: 100%;
                height: 100%;
            }

            cursor: pointer;
            &:hover {
                // background-color: #F5F7FA;
            }
            &:last-child {
                border-bottom: none;
            }
            .title {
                font-size: 14px;
                color: #333333;
                height: 25px;
                line-height: 25px;
                width: 96%;
                position: relative;
                padding-right: 10px;
                display: inline-block;
                .msg {
                    display: block;
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .no-read {
                    display: block;
                    width: 6px;
                    height: 6px;
                    border-radius: 6px;
                    background: red;
                    position: absolute;
                    left: -10px;
                    top: 12px;
                    z-index: 100;
                }
            }
            .bottom {
                font-size: 13px;
                color: #9b9b9b;
                height: 25px;
                line-height: 25px;
                font-family: MicrosoftYaHei;
                .name {
                    display: inline-block;

                    font-size: 13px;
                }
                .time {
                    display: block;
                    width: 106px;
                    float: right;
                    margin-right: 10px;
                    font-size: 13px;
                }
                .sender {
                    font-size: 12px;
                }
            }
        }
    }
    // .autoStyle{
    //     height: 100px !important;
    //     overflow-y: auto;
    // }
    // .autoStyle::-webkit-scrollbar{
    //     display: none;
    // }
}
</style>
